module.exports = __webpack_public_path__ + "img/station-array-triggered.b8b3c482.png";